
// const getCoords = () => {
//   return new Promise((resolve, reject) => {
//     // Check if Permission API is implemented
//     if (navigator.permissions) {
//       navigator.permissions.query({ name: 'geolocation' })
//         .then((permission) => {
//           // Check if geolocation is granted or prompt
//           if (permission.state === 'granted' || permission.state === 'prompt') {
//             // Get the current position if available
//             navigator.geolocation.getCurrentPosition((pos) => {
//               // Resolve with the coordinates
//               resolve(pos.coords);
//             }, (error) => {
//               // Handle errors with the geolocation API
//               reject(new Error(`Geolocation error: ${error.message}`));
//             }, {
//               // Add a timeout in case the geolocation API takes too long to respond
//               timeout: 10000,
//               // best possible results (this can result in slower response times or increased power consumption)
//               enableHighAccuracy: true,

//             });
//           } else {
//             // Geolocation permission was not granted or prompt
//             resolve(null);
//           }
//         })
//         .catch((error) => {
//           // Handle errors with the Permission API
//           reject(new Error(`Permission error: ${error.message}`));
//         });
//     } else {
//       // Permission API is not implemented
//       resolve(null);
//     }
//   });
// };

function getCoords() {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      resolve(null); // browser doesn't support it
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve(position.coords);
      },
      (error) => {
        // User denied permission
        if (error.code === error.PERMISSION_DENIED) {
          resolve(null);
          return;
        }

        // Other errors (timeout, unavailable)
        reject(error);
      },
      {
        enableHighAccuracy: false, // safer default
        timeout: 10000,
        maximumAge: 60000,
      }
    );
  });
}

export default getCoords;
